import React from 'react';

interface Props {
  visible: boolean;
  vpm: number | null;
  textPreview?: string;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'bottom-center';
}

const positionClass: Record<NonNullable<Props['position']>, string> = {
  'top-right': 'top-4 right-4',
  'top-left': 'top-4 left-4',
  'bottom-right': 'bottom-4 right-4',
  'bottom-left': 'bottom-4 left-4',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2'
};

const VocalsPerMinuteOverlay: React.FC<Props> = ({ visible, vpm, textPreview, position = 'bottom-center' }) => {
  if (!visible) return null;
  return (
    <div className={`fixed z-[9999] pointer-events-none ${positionClass[position]} `}>
      <div className="backdrop-blur-md bg-black/40 border border-white/20 rounded-full px-4 py-2 shadow-lg flex items-center gap-2">
        <div className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" />
        <span className="text-white text-sm font-semibold">{vpm != null ? `${vpm} VPM` : 'VPM'}</span>
        {textPreview && (
          <span className="text-gray-300 text-xs max-w-[240px] truncate">{textPreview}</span>
        )}
      </div>
    </div>
  );
};

export default VocalsPerMinuteOverlay;


